<div
  class="relative bg-cover bg-center rounded-[30px] shadow-md p-6 min-h[790px] installation-questions"
  [ngStyle]="{
    'background-image': 'url(/images/questions/1.png)'
  }"
>
  <div class="py-8 lg:py-14 container">
    <div class="flex w-full flex-wrap">
      <div class="w-full lg:w-4/12 lg:pr-4 left-content">
        <h2 class="title pb-3">Installation Questions</h2>
        <p class="details pr-4">
        </p>
      </div>
      <div class="w-full lg:w-8/12">
        <div class="accordion">
          <p-accordion value="0">
            <p-accordion-panel
              *ngFor="let faq of installationQuestions.faqs; let i = index"
              [value]="i"
            >
              <p-accordion-header>
                <ng-template #toggleicon let-active="active">
                  <!-- Toggle Icons -->
                  <div
                    *ngIf="active"
                    class="rounded-full border-[2px] border-[#fff] w-[26px] h-[26px] flex items-center justify-center icon-box"
                  >
                    <i class="pi pi-minus"></i>
                  </div>
                  <div
                    *ngIf="!active"
                    class="rounded-full border-[2px] border-[#fff] w-[26px] h-[26px] flex items-center justify-center icon-box"
                  >
                    <i class="pi pi-plus"></i>
                  </div>
                </ng-template>
                {{ faq.question }}
              </p-accordion-header>
              <p-accordion-content>
                <p class="m-0">{{ faq.answer }}</p>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
